import { render, staticRenderFns } from "./Resultado.vue?vue&type=template&id=0f3e94f1&scoped=true"
import script from "./Resultado.vue?vue&type=script&lang=js"
export * from "./Resultado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3e94f1",
  null
  
)

export default component.exports